import React, { useEffect, useState } from 'react'
import Helper from 'src/support/Helper';
import Common from './Common';
import { isArray } from "underscore";

const PriceTableForFarnell = (props) => {
    const {single_product_pricing_list} = props;
    const [linesToDisplay, setLinesToDisplay] = useState(2);
    const [priceTableExpanded, setPriceTableExpanded] = useState(false)
    const { no_bold_price_line_needed } = props;
    const [visibility_state, set_visibility_state] = useState(true);
    
    useEffect(() => {
        setLinesToDisplay(props.linesToDisplay === undefined ? 3 : props.linesToDisplay)
    }, [props.linesToDisplay])

    useEffect(() => {
        if (priceTableExpanded) {
            setLinesToDisplay(100)
        }
    }, [priceTableExpanded])

    const get_single_product_pricing_list_length = () => {
        try {
            return single_product_pricing_list !== undefined && isArray(single_product_pricing_list) ? single_product_pricing_list.length : 0;
        } catch (e) {
        }
        return 0;
    };

    const getLinesToDisplayProp = () => {
        return props.linesToDisplay === undefined ? 3: props.linesToDisplay;
    };

    const getPriceLineClass = (isPLP, priceArray, rowIndex, linesToDisplay) => {
        if (isPLP !== undefined && isPLP === true) {
            return (rowIndex == 0 || rowIndex === (priceArray.length - 1)) ? '' : 'none'
        }
        return (rowIndex + 1) > linesToDisplay ? 'none' : ''
    };
    
    const  template_for_pricing = (single_product_pricing_list, single_product_pricing_list_length, getClassFROMUI, linesToDisplay = 100,  isPLP = false, visibility = true) => {
        //visibility will be mainly used by loader so please take decision based on that
         let option_style = {
            visibility: visibility ? 'visible' : 'hidden'
        };
        const getPriceStyle = (demandQuantityOut) => {
            if (demandQuantityOut === undefined || demandQuantityOut === null || isNaN(demandQuantityOut) || Number(demandQuantityOut) <= 0) {
                return 'hidden';
            }
            if (visibility === false) {
                return 'hidden';
            }
            return 'visible'
        };
        const getDemandQty = (demandQtyOut) => {
            return demandQtyOut + "+";
        }
        
        return (
            <>
                {single_product_pricing_list !== undefined &&
                    single_product_pricing_list_length > 0 &&
                    <div className="price-table-list">
                        {single_product_pricing_list.map((v, i) => (
                            <div className={'bs5 row mx-0 ' + getClassFROMUI(v, i)} key={i} style={
                                {
                                    ...option_style,
                                    display: getPriceLineClass(isPLP, single_product_pricing_list, i, linesToDisplay),
                                }
                            }>
                                <div className="ps-0 col-6 font-12"
                                    style={{ visibility: getPriceStyle(v.From) }}>
                                    <span>{getDemandQty(v.From)}</span></div>
                                <div className="pe-0 col-6 text-end font-12">
                                    <span>{Helper.getFormatNumber(Number(v?.Cost), 'GBP', '£', 5)}</span>
                                </div>
                            </div>
                        ))
                        }
                    </div>
                }
            </>
        );
    }; 

    const getClass = (single_price, current_index) => {
        let d = new Common().getClassForFarnellInventory(single_price, current_index, single_product_pricing_list, 0, false)
        if (no_bold_price_line_needed !== undefined &&
            no_bold_price_line_needed === true
        ) {
            return ' ';
        }
        return d ? 'font-bold' : ' ';
    };

    return (
        <>
            {template_for_pricing(single_product_pricing_list, get_single_product_pricing_list_length(), getClass, linesToDisplay,(linesToDisplay === 2 ? true : false), visibility_state)}
            <a className='text-blue2 d-flex mt-1' href={void (0)} style={{
                paddingLeft: '0',
                visibility: visibility_state ? 'visible' : 'hidden'
            }} onClick={() => {
                if (linesToDisplay === getLinesToDisplayProp()) {
                    setLinesToDisplay(100)
                    setPriceTableExpanded(true)
                } else {
                    setLinesToDisplay(getLinesToDisplayProp())
                }
            }
            }>
                {single_product_pricing_list.length > (getLinesToDisplayProp() - 1) &&
                    <>
                        {linesToDisplay < single_product_pricing_list.length &&
                            <>
                                <span className='font-bold font-12'>More Pricing </span>
                                <i className="fa fa-angle-down font-bold font-18 ms-1"></i>
                            </>
                        }
                        {linesToDisplay !== getLinesToDisplayProp() &&
                            <>
                                <span className='font-bold font-12'>Less Pricing </span>
                                <i className="fa fa-angle-up font-bold font-16 ms-1"></i>
                            </>
                        }
                    </>
                }
            </a>
        </>
    )
}

export default PriceTableForFarnell
